import { memo, useMemo } from "react";
import { markMatch, prepareForMatching } from "@datassential/platform-ui-lib";
import { IMacListItem } from "@models/MacListItem";
import MacsListMoreLabel from "../MacsListMoreLabel/MacsListMoreLabel";

interface MacsListRowDescriptionProps {
    query: string;
    row: IMacListItem;
}

const PREVIEW_ITEMS_COUNT = 2;

const MacsListRowDescription = ({ query, row }: MacsListRowDescriptionProps) => {
    const sanitizedQuery = useMemo(() => prepareForMatching(query), [query]);
    const sanitizedAdditional = useMemo(
        () => prepareForMatching(row.description.additional),
        [row.description.additional]
    );
    const hasMatchInAdditional = useMemo(
        () => markMatch(sanitizedAdditional, sanitizedQuery, true).includes(sanitizedQuery),
        [sanitizedAdditional, sanitizedQuery]
    );
    const highlightedPreview = useMemo(
        () => sanitizedQuery === ''
            ? row.description.preview
            : markMatch(row.description.preview, sanitizedQuery, true),
        [sanitizedQuery, row.description.preview]
    );

    return (
        <div>
            <div
                className="MacsListTable__row-description-preview"
                dangerouslySetInnerHTML={{ __html: highlightedPreview }}
            />
            {' '}
            {row.itemsCount > PREVIEW_ITEMS_COUNT && (
                <MacsListMoreLabel
                    rowId={row.id}
                    count={row.itemsCount - PREVIEW_ITEMS_COUNT}
                    isHighlighted={!!sanitizedQuery && hasMatchInAdditional}
                />
            )}
        </div>
    );
};

export default memo(MacsListRowDescription);
